import { useState, useEffect, FC } from "react";
import { ReactSVG } from "react-svg";
import { Box, Card } from "@chakra-ui/react";
import ClassNames from "classnames";
import "../css/map.css";
import "../css/GridPatternUsageInfo.scss";
import { SeatStatus } from "./types/TypeMapData";
import IconWc from "../images/icon_wc.png";
import IconWcMen from "../images/icon_wc_men.png";
import IconWc_women from "../images/icon_wc_women.png";
import IconEv from "../images/icon_ev.png";
import { HeightCalculation, WidthCalculation } from "./SizeCaluculation";
// @ts-ignore　prescriptsにより`university_data.json` を `client/src` フォルダに移動させるため
import universityData from "../json/university_data.json";
/**
 * フロアマップコンポーネント。
 * - 各フロアを切り替えて、対応するSVGマップを表示。
 * - 地図上にアイコン（トイレ、エレベーターなど）を表示。
 * - 座席の状態に基づいてSVG要素に状態を反映。
 *
 * @param {SeatStatus[]} seatStatus - 各座席の状態リスト。
 * @param {boolean} isFetching - データがフェッチ中かどうかを示すフラグ。
 */

type props = {
  seatStatus: SeatStatus[];
  isFetching: boolean;
};

const Map: FC<props> = (props) => {
  const { seatStatus, isFetching } = props;
  const [currentFloor, setCurrentFloor] = useState<number>(1);
  const [floorPath, setFloorPath] = useState<string>(
    `${process.env.PUBLIC_URL}/svg/icommons-map-1f.svg`
  );
  const [width, setWidth] = useState<number>(WidthCalculation(1170, 1170));
  const [height, setHeight] = useState<number>(HeightCalculation(691, 691));

  const handleSvgLoaded = () => {
    let reserveItems = document.getElementsByClassName("reserve_items");
    console.log("SVG Loaded");
    for (let i = 0; i < reserveItems.length; i++) {
      reserveItems[i].classList.add("status-available");
    }

    seatStatus.forEach((currentValue) => {
      let generateId = "reserve_" + currentValue.item_id;
      let list = document.getElementById(generateId);
      if (list) {
        let elementList = list.children;

        let status_class;
        switch (currentValue.object_status) {
          case "1":
            status_class = "status-available";
            break;
          case "2":
            status_class = "status-commingsoon";
            break;
          case "3":
            status_class = "status-full";
            break;
          default:
            status_class = "status-available";
            break;
        }

        if (elementList) {
          for (let i = 0; i < elementList.length; i++) {
            elementList[i].classList.add(status_class);
          }
        }
      }
    });
  };

  const handleChangeFloor = (currentFloor: number) => {
    const floorPaths = Object.values(universityData.university.floor_map_svg);
    setCurrentFloor(currentFloor);
    // @ts-ignore　@ts-ignore　prescriptsにより`university_data.json` を `client/src` フォルダに移動させるためunknownになることはない
    setFloorPath(floorPaths[currentFloor]);
  };

  console.log("floorPath", floorPath);
  const floors = Object.keys(universityData.university.floor_map_svg);

  // 各フロアに対してクラスを動的に生成
  let floors_css: { [key: string]: string } = {};
  floors.forEach((floor, index) => {
    floors_css[`cx${floor}`] = ClassNames({
      floor_map_button: true,
      select: currentFloor === index,
    });
  });

  console.log("floors_css", floors_css);
  return (
    <Card className="card_outer">
      <div className="map_left_container">
        <div className="floor_map_title">
          <span className="commons">
            {universityData.university.label} INFINITY COMMONS
          </span>
          <br />
          フロアマップ
        </div>
        <div className="floor_map_button_container">
          {floors.map((floor, index) => (
            <div
              key={floor}
              className={floors_css[`cx${floor}`]}
              onClick={() => handleChangeFloor(index)}
            >
              <p style={{ textAlign: "center" }}>{floor}</p>
            </div>
          ))}
        </div>
        <div className="floor_map_marker_container">
          <div className="center_container">
            <div className="floor_map_marker">
              <div className="floor_map_marker_icon">
                <img src={IconWcMen} />
              </div>
              <div className="floor_map_marker_title">
                <p>男性用トイレ</p>
              </div>
            </div>

            <div className="floor_map_marker">
              <div className="floor_map_marker_icon">
                <img src={IconWc_women} />
              </div>
              <div className="floor_map_marker_title">
                <p>女性用トイレ</p>
              </div>
            </div>
            <div className="floor_map_marker">
              <div className="floor_map_marker_icon">
                <img src={IconWc} />
              </div>
              <div className="floor_map_marker_title">
                <p>多目的トイレ</p>
              </div>
            </div>

            <div className="floor_map_marker">
              <div className="floor_map_marker_icon">
                <img src={IconEv} />
              </div>
              <div className="floor_map_marker_title">
                <p>エレベーター</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isFetching ? (
        <Box
          className="map_right_container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReactSVG
            src={floorPath}
            afterInjection={(svg) => {
              svg.setAttribute("style", ` height: ${height}px; width:${width}`);
              handleSvgLoaded();
            }}
            beforeInjection={(svg) => {
              svg.setAttribute("style", ` height: ${height}px; width:${width}`);
            }}
          />
        </Box>
      ) : (
        <Box className="map_right_container" />
      )}
    </Card>
  );
};

export default Map;
